import React, { useEffect, useRef } from 'react';
import { node, string } from 'prop-types';
import useMedia from '../../../../hooks/useMedia';
import { MEDIA_TYPE } from '../../../../constants/screenConstants';
import './Footer.scss';

const Footer = props => {
    const { children, footerClass } = props;
    const elementRef = useRef(null);
    const mediaType = useMedia();

    useEffect(() => {
        if (elementRef.current) {
            const elementHeight = elementRef.current.clientHeight;
            const globalFooter = document.querySelector('.globalFooter');
            if (globalFooter) {
                if (mediaType !== MEDIA_TYPE.DESKTOP ) {
                    globalFooter.style.marginBottom = `${elementHeight}px`;
                } else {
                    globalFooter.style.marginBottom = '0px';
                }
            }
        }
    },[elementRef])

    return <div ref={elementRef} className={`cart-footer ${footerClass}`}>{children}</div>;
};

export default React.memo(Footer);

Footer.propTypes = {
    children: node,
    footerClass: string
};

Footer.defaultProps = {
    footerClass: ''
};
